// extracted by mini-css-extract-plugin
export default {"container":"Edit_container__sOR7X","mobile":"Edit_mobile__0qegl","deleteButton":"Edit_deleteButton__3BNuc","modalCloseButton":"Edit_modalCloseButton__jdVYe"};